import { DialogContent, DialogTitle, Paper, Popover, TextField } from "@mui/material";
import MuiContainer from "components/MuiExtras/MuiContainer";
import * as React from "react";
import { useTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    anchorEl: HTMLElement;
    onSelect: (value: string) => void;
    label?: string;
    placeholder?: string;
}

/////////////////////////////////////////////////////////////////////////////////////

const TextPickerPopper: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    let searchRef: any = null;
    const label = props.label || t("Common.Input.Label.SearchFor");
    const placeholder = props.placeholder || t("Common.Input.Placeholder.SearchByText");

    return (
        <Popover
            disablePortal={false}
            open={true}
            anchorEl={props.anchorEl}
            style={{ zIndex: 13000 }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            onBackdropClick={() => props.onSelect(null)}
        >
            <Paper square={true} style={{ width: props.anchorEl.clientWidth }} >

                <DialogTitle>
                    <span>{label}</span>
                </DialogTitle>

                <DialogContent >
                    <MuiContainer>
                        <TextField
                            autoFocus
                            fullWidth
                            placeholder={placeholder}
                            inputRef={(ref) => searchRef = ref}
                            InputProps={
                                {
                                    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                                        if (e.keyCode == 13) props.onSelect(searchRef.value);
                                        if (e.keyCode == 27) props.onSelect(null);
                                    }
                                }
                            }
                        />
                    </MuiContainer>
                </DialogContent>
            </Paper>
        </Popover>
    );
};

export default TextPickerPopper;
